import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import classnames from 'classnames';
let Image = /*#__PURE__*/function (_React$Component) {
  function Image(props) {
    return _React$Component.call(this, props) || this;
  }
  _inheritsLoose(Image, _React$Component);
  var _proto = Image.prototype;
  _proto.onImageLoad = function onImageLoad() {
    // Could fade in here
  };
  _proto.render = function render() {
    const className = classnames('image', 'img-fluid', this.props.rounded && 'rounded-circle', this.props.className);
    const newProps = _objectSpread(_objectSpread({}, this.props), {}, {
      className
    });
    return /*#__PURE__*/React.createElement("img", Object.assign({
      onLoad: this.onImageLoad,
      alt: ""
    }, newProps));
  };
  return Image;
}(React.Component);
export default Image;